import TagButton from "../../../../../components/features/TagButton";
import { Text } from "../../../../../components/general/Text";
import { Tag } from "../DownloadForm";
import { TagGroup } from "./TagGroup";

export type GroupedTags = {
  status: Tag[];
  job: Tag[];
  tag_ids: Tag[];
};

type Props = {
  selectedTagIds: string[];
  tags: Tag[];
  groupedTags: GroupedTags;
  onRemoveTag: (tagId: string) => void;
  onTagToggle: (tagId: string) => void;
};

export const TagSelectionDisplay = ({
  selectedTagIds,
  tags,
  groupedTags,
  onRemoveTag,
  onTagToggle,
}: Props) => {
  const renderTagGroups = () => {
    const tagGroups = [
      { title: "生徒連携状態タグ", tags: groupedTags.status },
      { title: "学年タグ", tags: groupedTags.job },
      { title: "校舎独自タグ", tags: groupedTags.tag_ids },
    ];

    return tagGroups.map(({ title, tags }) => (
      <TagGroup
        key={title}
        title={title}
        tags={tags}
        selectedTagIds={selectedTagIds}
        onTagToggle={onTagToggle}
      />
    ));
  };

  return (
    <div>
      <div className="mb-8 max-h-[30vh] overflow-y-auto pr-2">
        {renderTagGroups()}
      </div>
      <div className="pt-8 mb-8">
        <Text size="md" className="mb-4 text-gray-800 font-medium">
          タグの選択
        </Text>
        <div className="rounded-lg p-4 bg-white border border-solid border-gray-300">
          <div className="flex flex-wrap gap-2 min-h-[5rem] items-center">
            {selectedTagIds.length > 0 &&
              selectedTagIds.map((tagId) => {
                const tag = tags.find((t) => t.id === tagId);
                if (!tag) {
                  return null;
                }
                return (
                  <TagButton
                    key={tag.id}
                    label={tag.name}
                    variant="outline"
                    colorType="primary"
                    iconName="icon-close-x"
                    onClick={() => onRemoveTag(tag.id)}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
};
